import Typography from "@material-ui/core/Typography";
import { createMuiTheme, TextField } from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { ThemeProvider } from "react-bootstrap";

const theme = createMuiTheme({
  palette: {
    error: {
      main: "#3f51b5",
    },
  },
});

const useStyles = makeStyles({
  textFieldContainer: {
    display: "flex",
    margin: 10,
  },
  label: { width: "40%" },
  input: { width: "60%" },
});

function TextFieldForms(props) {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.textFieldContainer}>
        <div className={classes.label}>
          <Typography>{props.label}</Typography>
          <Typography variant="caption" style={{ color: "gray" }}>
            {props.helperTextLabel ?? ""}
          </Typography>
        </div>
        <div className={classes.input}>
          <TextField
            helperText={props.helperText ?? ""}
            onBlur={props.onBlur ?? null}
            placeholder={props.placeholder ?? ""}
            required={props.required ?? false}
            disabled={props.disabled ?? false}
            type={props.type ?? "text"}
            error={props.error ?? false}
            size={"small"}
            variant={props.variant ?? "outlined"}
            inputProps={props.inputProps ?? {}}
            fullWidth
            value={props.value ?? ""}
            onChange={props.onChange}
            InputProps={props.InputProps ?? null}
          />
        </div>
      </div>
    </ThemeProvider>
  );
}

TextFieldForms.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TextFieldForms;
